import React, { Component, Suspense, lazy } from "react";
import Login from "./components/Login/LoginComponent/Login";
import "./App.scss";
import "@noku-tech/nokulibrary-frontend/dist/index.css";
import { Route, Switch } from "react-router-dom";
import { connect } from 'react-redux';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Notification from './components/UI/Notification/Notification';

import { library } from "@fortawesome/fontawesome-svg-core";
import { Offline } from "react-detect-offline";

import { setCustomizationId, setMobile, setLanguages } from "./store/actions";

import { getI18n } from "react-i18next";

import {
  faKey,
  faEnvelope,
  faCameraAlt,
  faSignOutAlt,
  faUserCircle,
  faGlobe
} from "@fortawesome/pro-light-svg-icons";

import {
  faBell,
} from "@fortawesome/pro-regular-svg-icons";

import {
  faSortDown,
  faAngleDown,
  faArrowDown,
  faArrowUp,
  faCoins,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";

import {
  faBellOn as faBellOnSolid,
  faCheckDouble,
  faStarChristmas,
  faArrowDownToLine,
  faSliders,
	faTrophy,
  faXmark,
} from "@fortawesome/pro-solid-svg-icons";

import VerifiedEmailPage from "./pages/VerifiedEmailPage/VerifiedEmailPage";
import ValidateCodePage from "./pages/ValidateCodePage/ValidateCodePage";

import Loading from "./components/Loading/Loading";

const Dialog = lazy(() => import("./components/Misc/Oauth2/Dialog/Dialog"));

const ResetPassword = lazy(() => import("./components/Login/ResetPasswordComponent/ResetPassword"));

const Start = lazy(() => import("./components/Start/StartComponent/Start"));

const Signup = lazy(() => import("./components/Login/SignupComponent/Signup"));

const Forgot = lazy(() => import("./components/Login/ForgotComponent/ForgotComponent"));

const Home = lazy(() => import("./components/Home/HomeComponent/HomeComponent"));

library.add(
  faKey,
  faEnvelope,
  faCameraAlt,
  faSignOutAlt,
  faUserCircle,
  faSortDown,
  faAngleDown,
  faGlobe,
  faArrowDown,
  faArrowUp,
  faCoins,
  faCheck,
  faSliders,
  faCheckDouble,
  faArrowDownToLine,
  faStarChristmas,
  faBell,
  faBellOnSolid,
  faTrophy,
  faXmark,
);

let recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_KEY;

class App extends Component {
  constructor(props) {
    super(props);
    this.appendFreshdeskScript();
    this.setCustomizationVariables();

    this.i18n = getI18n();
  }

  componentDidMount() {
    this.setupLanguages();
    this.props.setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", () => this.props.setIsMobile(window.innerWidth < 768));
  }

  componentDidUpdate(prevProps) {
    if (this.props.currentLanguage !== prevProps.currentLanguage) {
      this.i18n?.changeLanguage?.(this.props.currentLanguage);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => { });
  }

  setupLanguages = async () => {
    let { languages, language } = this.i18n;
    // Remove country-coded language (like it-ch, en-gb) from current language
    if (language?.includes('-')) {
      await this.i18n?.changeLanguage?.(language.split('-')[0]);
    }

    // Remove country-coded languages (like it-ch, en-gb)
    languages = languages?.filter?.((language) => !language?.includes('-'));

    if (process.env.REACT_APP_BRAND_ID === "legallab") {
      await this.i18n?.changeLanguage?.('en');
    }
    if (languages) {
      this.props.setLanguages(languages);
    }
  }

  appendFreshdeskScript = () => {
    const freshdeskId = process.env.REACT_APP_FRESHDESK_ID;
    if (freshdeskId) {
      window.fwSettings = {
        'widget_id': freshdeskId
      };
      let n = function () { n.q.push(arguments); };
      n.q = [];
      window.FreshworksWidget = n;

      const script = document.createElement("script");
      script.src = `https://euc-widget.freshworks.com/widgets/${freshdeskId}.js`;
      script.async = true;
      document.body.appendChild(script);

    }
  }

  setCustomizationVariables = () => {
    this.props.setCustomizationId(process.env.REACT_APP_BRAND_ID);
  }

  render() {
    return (
      <Suspense fallback={<Loading />}>
        <div className={"bodywrapper"}>
          <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
            <Notification />
            <Offline polling={{ url: `${process.env.REACT_APP_DOMAIN}/api/online`, interval: 10000, enabled: true, timeout: 20000 }}>
              <div className="offline"></div>
            </Offline>
            <Switch>
              <Route path="/home" component={Home} />
              <Route exact path='/' render={(routeProps) => <Login {...routeProps} />} />
              <Route path="/dialog" component={Dialog} />
              <Route path="/verified-email" component={VerifiedEmailPage} />
              <Route path="/validate-code" component={ValidateCodePage} />
              {
                process.env.REACT_APP_IS_NOKU === "true" ?
                  <>
                    <Route path="/signup" component={Signup} />
                    <Route path="/forgot" component={Forgot} />
                    <Route path="/reset" component={ResetPassword} />
                  </>
                  :
                  <>
                    <Route exact path='/start' component={Start} />
                  </>
              }
            </Switch>
          </GoogleReCaptchaProvider>
        </div>
      </Suspense>
    );
  }
}

const mapStateToProps = ({ base }) => {
  return { currentLanguage: base?.currentUser?.preferredLanguage };
};

const mapDispatchToProps = dispatch => ({
  setCustomizationId: customizationId => dispatch(setCustomizationId(customizationId)),
  setIsMobile: isMobile => dispatch(setMobile(isMobile)),
  setLanguages: (languages) => dispatch(setLanguages(languages)),
});


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
